import type { Session } from '@halo/chat-sdk-react';
import { formatDuration } from '@halo/utils';
import { MsgMediaCard, MsgMediaCardContent } from '../msg-media-card';
import type { MsgMediaCallNetworkErrorContentProps } from './msg-media-call-network-error-content';

export interface MsgMediaCallNetworkErrorProps extends MsgMediaCallNetworkErrorContentProps {
  session: Session;
}

export const MsgMediaCallNetworkError = memo(function MsgMediaCallNetworkError({
  message,
  session,
}: MsgMediaCallNetworkErrorProps) {
  const { t } = useTranslation();

  const { call_started_at, created_at, now_time } = message.payload;

  const duration = useMemo(
    () => formatDuration(now_time - (call_started_at || created_at)),
    [now_time, call_started_at, created_at]
  );

  return (
    <MsgMediaCard message={message} session={session}>
      <MsgMediaCardContent
        message={message}
        session={session}
        isError={true}
        title={t('calls.callNetErrorTitle')}
        description={t('calls.callNetError', { count: duration as any })}
      ></MsgMediaCardContent>
    </MsgMediaCard>
  );
});
